export default {
    "APP_ORDERS_VIEW": "",
    "APP_PRODUCTS_VIEW": "",
    "APP_AUDIT_VIEW": "",
    "APP_PRDT_DTLS_VIEW": "",
    "APP_AUDIT_PRDT_DTLS_VIEW": "",
    "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
    "MERCHANDISING_ADMIN": "MERCHANDISING_ADMIN",
    "PREORDER_APP_VIEW": "PREORDER_APP_VIEW",
    "APP_INV_CNFG_UPDT": "COMMON_ADMIN",
    "APP_PRODUCT_IDENTIFIER_UPDATE": "COMMON_ADMIN",
    "APP_PWA_STANDALONE_ACCESS": "COMMON_ADMIN",
} as any